import { useEffect, useState } from "react";
import type { LinkedAccount } from "@store/linkedAccountSlice";

/** 解析一个可用的账号 linkId：优先用 preferred（若仍在列表中），否则取第一个。 */
export const resolveSelectableLinkId = (accounts: LinkedAccount[], preferredLinkId?: number): number | undefined => {
  if (preferredLinkId !== undefined && accounts.some((account) => account.id === preferredLinkId)) {
    return preferredLinkId;
  }
  return accounts[0]?.id;
};

/**
 * 维护当前选中的账号 linkId：
 * - 初始用 preferred（或第一个）。
 * - accounts 刷新后，若当前选择仍有效则保留（不会因刷新被重置回 preferred），否则重新解析。
 */
export const useAccountSelection = (accounts: LinkedAccount[], preferredLinkId?: number) => {
  const [selectedLinkId, setSelectedLinkId] = useState<number | undefined>(() =>
    resolveSelectableLinkId(accounts, preferredLinkId),
  );

  useEffect(() => {
    setSelectedLinkId((prev) =>
      prev !== undefined && accounts.some((account) => account.id === prev)
        ? prev
        : resolveSelectableLinkId(accounts, preferredLinkId),
    );
  }, [accounts, preferredLinkId]);

  return [selectedLinkId, setSelectedLinkId] as const;
};
